/*
 * 纯util工具类，不涉及业务逻辑
 */
import qs from "qs";
import CookieUtils from "../libs/esg-acsp-core-vue-lib/utils/CookieUtils";
import { queryUrlVal } from "@/libs/esg-acsp-core-vue-lib/utils/Tools";
import axios from "axios";

/**
 * 跳入PC旧版主包
 * @param {*} url
 */
export const jumpPortal = function (url = "/") {
  location.href = url;
};

/**
 * 跳入B端登录
 */
export const jumpBLogin = function () {
  // B端登录页回调URL
  let bCallbackUrl = encodeURIComponent(location.href);
  const redirectUri = encodeURIComponent(
    `${location.protocol}//${location.host}/middle`
  );
  if (location.pathname === "/login") {
    // 登录页 登录成功回调的url
    bCallbackUrl = encodeURIComponent(
      queryUrlVal("redirectUrl") || `${location.protocol}//${location.host}`
    );
  }
  localStorage.setItem("store-skipPageUrl", bCallbackUrl);
  location.href = `${process.env.VUE_APP_B_ACCOUNT_DOMAIL}/login?redirect_uri=${redirectUri}`;
};

/**
 * 跳入B端注册
 */
export const jumpBRegister = function () {
  // B端登录页回调URL
  let bCallbackUrl = encodeURIComponent(location.href);
  const redirectUri = encodeURIComponent(
    `${location.protocol}//${location.host}/middle`
  );
  if (location.pathname === "/login") {
    // 登录页 登录成功回调的url
    bCallbackUrl = encodeURIComponent(
      queryUrlVal("redirectUrl") || `${location.protocol}//${location.host}`
    );
  }
  localStorage.setItem("store-skipPageUrl", bCallbackUrl);
  location.href = `${process.env.VUE_APP_B_ACCOUNT_DOMAIL}/legacyUsersRegister?redirect_uri=${redirectUri}`;
};

/**
 * B端退出登录
 */
export const bLogout = function () {
  location.replace(
    `${process.env.VUE_APP_B_ACCOUNT_DOMAIL}/api/subsystem/pb/token/logout?redirect_uri=${location.href}`
  );
};

/**
 * url添加参数，存在就覆盖
 * @param url
 * @param key
 * @param value
 */
export const urlAppendQuery = function (url = "", query = {}) {
  if (url) {
    let urlArr = url.split("?");

    let path = urlArr[0];
    let queryStr = urlArr[1];

    if (queryStr) {
      let _query = qs.parse(queryStr);
      query = { ..._query, ...query };
    }

    return path + "?" + qs.stringify(query);
  }
  return url;
};

/**
 * 对象转queryString
 * @param obj
 * @returns {string}
 */
export const toQueryString = (obj) => {
  return Object.keys(obj)
    .map((key) => {
      const val = obj[key];
      if (typeof val === "string") {
        return `${key}=${val}`;
      } else {
        return `${key}=${JSON.stringify(val)}`;
      }
    })
    .join("&");
};

export const checkIsBill = (router = {}) => {
  // ['/开具发票编辑', '/支付', '/支付成功', '/支付失败']
  return (
    ["/InvoiceEdit", "/Pay", "/Pay/success", "/Pay/failure"].findIndex(
      (val) => val === router.path
    ) > -1
  );
};

export const getCompleteIframeUri = (route = {}) => {
  const { path } = route;
  if (!path || path === "undefined" || !checkIsBill(route)) return "";
  const envRoute = CookieUtils.getCookie("grayScale") === "1" ? "/g" : "/web";
  return `${envRoute}/bill${path}`;
};

// url跳转 - 新开标签页
export const jumpLink = (link) => {
  if (!link) return;
  let a = document.createElement("a");
  a.setAttribute("href", link);
  a.setAttribute("target", "_blank");
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

/**
 * 标签方式下载
 * @param {*} url 下载链接
 * @param {*} fileName 下载出来的文件名
 * @param {*} fileType 下载出来的文件类型
 */
export const tagDownload = (url, fileName, fileType = "pdf") => {
  let a = document.createElement("a");
  a.download = `${fileName}.${fileType}`;
  a.href = url;
  document.body.appendChild(a); // 修复firefox中无法触发click
  a.click();
  document.body.removeChild(a);
};

// 姓名格式验证
export const nameVerify = (name) => {
  const oName = name.replace(/\s+/g, "");
  return /^[A-Za-z\d\u4e00-\u9fa5]{1,20}$/.test(oName); // 和pc之前的规则对齐
};

export const getStaticDomain = () => {
  let domain = "";
  if (location.href.indexOf("v.sf-express.com") >= 0) {
    domain = "https://v-static.sf-express.com";
  } else {
    domain = "https://v-static.sit.sf-express.com";
  }
  return domain;
};

/**
 * 防抖动函数(短时间内不重复触发一个事件)
 * @param {function} fn 触发的函数
 * @param {number} delay 超过多少毫秒时间触发
 */
export const debounce = (fn, delay = 300) => {
  let timerDebounce = null; // 声明一计时器
  return function () {
    let content = this;
    let args = arguments;
    clearTimeout(timerDebounce);
    timerDebounce = setTimeout(function () {
      fn.call(content, ...args);
    }, delay);
  };
};

/**
 * 金额千分位格式化
 * @param {*} value
 * @returns
 */
export const amountSeparatorFormatter = (value) => {
  if (!value) {
    return;
  }
  if (isNaN(value)) {
    return value;
  }
  let re = /(?=(?!\b)(\d{3})+$)/g;
  let val = Number(value).toFixed(2).toString();
  return val.slice(0, -3).replace(re, ",") + val.slice(-3);
};

/**
 * promise形式返回ant 的validate结果
 * @param {ant的form元素对象} formEleObj
 * @returns
 */
export const validateForm = (formEleObj) => {
  return new Promise((resolve) => {
    if (!formEleObj) {
      resolve(false);
      return;
    }
    formEleObj.validate((valid) => {
      resolve(valid);
    });
  });
};

/**
 * 银行卡格式化
 * @param {*} value
 * @returns
 */
export const bankNoFormatter = (value = "") => {
  if (!value) {
    return "";
  }
  value = value.replace(/\s+/g, "");
  return value.replace(/(....)(?=.)/g, "$1 ");
};

/**
 * 获取字符串长度 中文占2位，其他字符占1位
 * @param {*} value
 * @returns
 */
export const getUTFCodeLength = (value) => {
  if (!value) {
    return 0;
  }
  let len = 0;
  for (let i = 0; i <= value.length - 1; i++) {
    let chatCode = value.charCodeAt(i);
    if (chatCode >= 0 && chatCode <= 128) {
      len += 1;
    } else {
      len += 2;
    }
  }
  return len;
};
export const isProd =
  process.env.VUE_APP_ENV === "production" ||
  process.env.VUE_APP_ENV === "production_gray";
export const isDevelopment =
  process.env.VUE_APP_ENV === "development" ||
  process.env.VUE_APP_ENV === "development_gray";
/**
 * 鲁班配置
 * @param {*} name
 * @rerurns
 */
export const getLubanConfigByName = async (name) => {
  let url;
  if (isProd) {
    url = `https://acsp-public-static.sf-express.com/sfcdn/sfosspublic001/lowcode/luban_config/${name}`;
  } else if (isDevelopment) {
    url = `/sfcdn/web-public/lowcode/luban_config/${name}`;
  } else {
    url = `https://acsp-public-static.sit.sf-express.com/sfcdn/web-public/lowcode/luban_config/${name}`;
  }
  try {
    const { data } = await axios.get(url);
    return data;
  } catch (e) {
    console.log(e);
    return {};
  }
};
